export * from '../useComponentBreakpointsDeprecated';
